import React from 'react';

const defaultPageContext = {
    setPageName: () => {},
};

const PageContext = React.createContext(defaultPageContext);
export default PageContext;
